// Formata valor em Real Brasileiro
export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
}

// Formata valor compacto (ex: R$ 1,2M)
export function formatCurrencyCompact(value: number): string {
  if (value >= 1_000_000) {
    return `R$ ${(value / 1_000_000).toFixed(1)}M`
  }
  if (value >= 1_000) {
    return `R$ ${(value / 1_000).toFixed(1)}K`
  }
  return formatCurrency(value)
}

// Formata percentual
export function formatPercent(value: number, decimals = 1): string {
  return `${value.toFixed(decimals)}%`
}
